<template lang="pug">
v-container
  v-row(
    align="center"
    justify="center"
    )
      v-col(md="6")
        div(class="box-shape text-center")
          div(class="pb-1 mb-5")
            h1(class="pb-1" style="font-size:40px;") Reset Password
            p(style="color:#666666; font-weight: 400;") To keep your account safe and secure, please update your password.

          div(class="pb-5")
            v-alert(
              dismissible 
              text 
              color="red" 
              v-if="alert==true") {{errormsg}}

          div(class="d-flex flex-row")
            div(class="col-12 pl-0 pb-0")
              div(class="text-left pb-1" style="color: #5C5C5C;") New Password
              v-text-field(
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :rules="passwordRules"
                :type="show1 ? 'text' : 'password'"
                v-model='new_password'  
                class="input-group--focused"
                outlined
                @click:append="show1 = !show1"
                placeholder="New Password"
                @keyup="checkPass"
              )
            div(class="align-self-center" v-if="fieldPassword != 'hide'")
              v-icon(
                :color="fieldPassword ? 'green' : 'red'"
                ) {{ fieldPassword ? 'check_circle' : 'cancel' }}

          div(class="d-flex flex-row")
            div(class="col-12 pl-0 pb-0 pt-0")
              div(class="text-left pb-1" style="color: #5C5C5C;") Confirm New Password
              v-text-field(
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :rules="confirmPasswordRules"
                :type="show2 ? 'text' : 'password'"
                v-model='confirm_password'  
                placeholder='Confirm New Password' 
                class="input-group--focused"
                outlined
                @click:append="show2 = !show2"
                @keyup="checkPass"
              )
            div(class="align-self-center" v-if="fieldConfirmPassword != 'hide'")
              v-icon(
                :color="fieldConfirmPassword ? 'green' : 'red'"
                ) {{ fieldConfirmPassword ? 'check_circle' : 'cancel' }}

          div(class="box-info")
            p(style="margin-bottom: 4px;") Enter a new password:
            ul 
              li Minimum 8 characters
              li Upper & lower case characters
              li Symbol character
              li Numeric characters

          v-btn(
            color='blue-primary' 
            class="mt-5" 
            type='submit' 
            block style="color:white; padding:25px;" 
            :disabled="!formPassword || disabledButton"
            @click='resetpassword') CHANGE PASSWORD
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ResetPassword",
  data() {
    return {
      disabledButton: false,
      alert:false,
      new_password: "",
      confirm_password:"",
      errormsg: "Authentication Failed",
      show1: false,
      show2: false,
      passwordRules: [
          value => !!value || 'This field is required.',
          value => value.length >= 8 || 'Minimum 8 characters',
          value => value && /\d/.test(value) || 'There must be a numeric character',
          value => value && /[A-Z]{1}/.test(value) || "At least 1 uppercase letter",
          value => value && /[a-z]{1}/.test(value) || "At least 1 lowercase letter",
          value => value && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value) || 'At least one special character',
      ],
      confirmPasswordRules: [
        () => this.confirm_password.length != 0 || 'Please confirm your passwords',
        () => this.confirm_password == this.new_password || 'Confirm password does not match',
      ],
    };
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formPassword() {
      return (this.new_password === this.confirm_password && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])[A-Za-z\d`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]{8,}$/.test(this.new_password))
    },
    fieldPassword() {
      if ( this.new_password == '' ) {
        return 'hide'
      } else if ( this.new_password.length >= 8 && /\d/.test(this.new_password) && /[A-Z]{1}/.test(this.new_password) && /[a-z]{1}/.test(this.new_password) && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.new_password) ) {
        return true
      } else {
        return false
      }
    },
    fieldConfirmPassword() {
      if ( this.confirm_password == '' ) {
        return 'hide'
      } else if ( this.new_password.length >= 8 && /\d/.test(this.new_password) && /[A-Z]{1}/.test(this.new_password) && /[a-z]{1}/.test(this.new_password) && /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(this.new_password) && this.new_password == this.confirm_password ) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    //this.email = this.$route.query.email || ''
  },
  methods: {
    resetpassword() {
      this.disabledButton = true
      let confirm_password  = this.confirm_password;
      let code = this.$route.params.code
      this.$store.dispatch("VerifiedResetPass", { code, confirm_password })
        .then(res => {
          if(res.status == 200){
            this.alert = false
            this.$toasted.success("Successful password update", { icon : 'check_circle'});
            this.$router.push('/login')
          }
        })
        .catch(message => this.showError(message))
        .finally(() => this.disabledButton = false);
    },
    showError(message) {
      this.errormsg = message.response.data.error;
      this.alert = true
    },
    checkPass() {
      if (this.formPassword) this.confirmPasswordRules = false;
      else if (this.confirm_password.length == 0) this.confirmPasswordRules = ['Please confirm your passwordss'];
      else if (this.confirm_password != this.new_password) this.confirmPasswordRules = ['Confirm password does not match'];
      else this.confirmPasswordRules = [
        () => this.confirm_password.length != 0 || 'Please confirm your passwords',
        () => this.confirm_password == this.new_password || 'Confirm password does not match',
      ];
    },
  },
};
</script>

<style>
  .box-shape{
    background: #FFFFFF;
    box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.11);
    padding: 4rem;
    margin-top: 2rem;
  }

  .box-info{
    background: #F3F4F6;
    padding: 1.4rem;
    border-radius: 12px;
    color: #585858;
    text-align: left;
  }
</style>